import { useMemo, useEffect, useState } from "react";
import cls from "classnames";
import styles from "./index.module.scss";
import { ISelectionDetail, ISelection } from "logic/src/objects/chat/types";
import { EFileQueryType } from "logic/src/objects/chat/types";
import { findElementWithClass } from "logic/src/utils/dom";

interface IProps {
  text: string;
  selection: ISelectionDetail;
  onClick: (type: EFileQueryType, v: ISelection) => void;
  onClose: () => void;
}

const Popup = ({ text, selection, onClick, onClose }: IProps) => {
  const style = useMemo(() => {
    return {
      top: selection.mouseY,
      left: selection.mouseX,
    };
  }, [selection]);

  useEffect(() => {
    const handleClose = (e: MouseEvent) => {
      const container = findElementWithClass(e, styles.container);
      if (!container) {
        onClose();
      }
    };
    document.addEventListener("mouseup", handleClose);
    return () => document.removeEventListener("mouseup", handleClose);
  });
  return (
    <div className={styles.container} style={style}>
      <div
        className={styles.btn}
        onClick={() => onClick(EFileQueryType.key_point, selection)}
      >
        划线
      </div>
      <div
        className={styles.btn}
        onClick={() => {
          console.log("rj--", EFileQueryType.query, selection);
          onClick(EFileQueryType.query, selection);
        }}
      >
        提问
      </div>
      <div
        className={styles.btn}
        onClick={() => onClick(EFileQueryType.summary, selection)}
      >
        总结
      </div>
      <div
        className={styles.btn}
        onClick={() => onClick(EFileQueryType.translation, selection)}
      >
        翻译
      </div>
      <div
        className={styles.btn}
        onClick={() => onClick(EFileQueryType.explain, selection)}
      >
        解释
      </div>
      <div
        className={styles.btn}
        onClick={() => onClick(EFileQueryType.rewrite, selection)}
      >
        改写
      </div>
      <div
        className={styles.btn}
        onClick={() => onClick(EFileQueryType.expand, selection)}
      >
        扩写
      </div>
    </div>
  );
};

interface IPosition {
  x: number;
  y: number;
  id: string;
}

export const HighLightPopup = ({
  onRemove,
  onClick,
}: {
  onRemove: (id: string) => void;
  onClick: (type: EFileQueryType, id: string) => void;
}) => {
  const [position, setPosition] = useState<IPosition | null>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const highlightDom = findElementWithClass(e, "highlight-container");
      if (highlightDom && highlightDom.dataset.selectionId) {
        setPosition({
          x: e.x,
          y: e.y,
          id: highlightDom.dataset.selectionId,
        });
      } else {
        if (position) {
          setPosition(null);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  });

  const style = useMemo(() => {
    if (position) {
      return {
        top: position.y,
        left: position.x,
      };
    }
  }, [position]);

  if (position) {
    return (
      <div className={cls(styles.container, styles.highlight)} style={style}>
        <div className={styles.btn} onClick={() => onRemove(position.id)}>
          删除划线
        </div>
        <div
          className={styles.btn}
          onClick={() => onClick(EFileQueryType.query, position.id)}
        >
          提问
        </div>
        <div
          className={styles.btn}
          onClick={() => onClick(EFileQueryType.summary, position.id)}
        >
          总结
        </div>
        <div
          className={styles.btn}
          onClick={() => onClick(EFileQueryType.translation, position.id)}
        >
          翻译
        </div>
        <div
          className={styles.btn}
          onClick={() => onClick(EFileQueryType.explain, position.id)}
        >
          解释
        </div>
        <div
          className={styles.btn}
          onClick={() => onClick(EFileQueryType.rewrite, position.id)}
        >
          修改
        </div>
        <div
          className={styles.btn}
          onClick={() => onClick(EFileQueryType.expand, position.id)}
        >
          扩写
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Popup;
